<elcia-dropdown
  [control]="control()"
  [items]="items()"
  [label]="'product.unit-of-measure' | translate"
  [textField]="'description'"
  [valueField]="'code'"
/>
